
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import { Client, IInvoiceModel } from '@/services/api.service';
  import toDateFormatter from '@/filters/todate.formatter';
  import toCurrencyFormatter from '@/filters/tocurrency.formatter';

  @Component({
    props: {
      jobNumber: String,
      invoices: {
        type: Array as () => IInvoiceModel[],
        required: true
      }
    },
    filters: {
      toDate: toDateFormatter,
      toCurrency: toCurrencyFormatter
    }
  })
  export default class JobInvoiceList extends Vue {
    private deleteJobInvoice(invoice: IInvoiceModel) {
      this.$emit('on-delete-jobinvoice', invoice);
    }

    private canDelete(inv: IInvoiceModel): boolean {
      // Can only delete if the invoice has not been exported
      if (inv.invoiceBatch) {
        if (inv.invoiceBatch.closedDateTimeUtc) {
          return false;
        }
      }
      return true;
    }
    private getInvoiceStatus(inv: IInvoiceModel): string {
      if (inv.invoiceBatch) {
        if (inv.invoiceBatch.closedDateTimeUtc) {
          return 'Exported';
        } else {
          return 'Batched';
        }
      }
      // Default if no batch is set
      return 'Unlinked';
    }
  }
